import React, { Component } from 'react';
import { connect } from 'react-redux';
import TimeAgo from 'react-timeago';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import engStrings from 'react-timeago/lib/language-strings/en';
import Draggable from 'react-draggable';
import FontAwesome from 'react-fontawesome';
import './AppInfo.scss';

class AppInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShown: false,
            isOpen: false
        };
    }

    static getDerivedStateFromProps(nextProps) {
        // eslint-disable-next-line
        const deploy = new Object(nextProps.deploy);
        if (deploy.hasOwnProperty('env')) {
            const isRunningLocally = process.env.NODE_ENV === 'development';

            const isProd =
                nextProps.deploy.hasOwnProperty('env') && nextProps.deploy.env === 'production';

            if (!isRunningLocally && !isProd) {
                return { isShown: true };
            }
        }

        return null;
    }

    close() {
        this.setState({ isOpen: false });
    }

    open() {
        this.setState({ isOpen: true });
    }

    render() {
        if (!this.state.isShown) return null;

        return (
            <Draggable>
                <div className={`version-banner ${this.state.isOpen ? 'opened' : 'closed'}`}>
                    {this.state.isOpen ? (
                        <div>
                            <div className="close" onClick={() => this.close()} />
                            <table>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '0 0px 0px 6px' }}>
                                            <FontAwesome name="code-fork" />
                                        </td>
                                        <td>Branch: {this.props.build.branchName}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FontAwesome name="wrench" />
                                        </td>
                                        <td>Build #: {this.props.build.number}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FontAwesome name="clock-o" />
                                        </td>
                                        <td>
                                            Built{' '}
                                            <TimeAgo
                                                formatter={buildFormatter(engStrings)}
                                                date={this.props.build.date}
                                                live
                                                title={this.props.build.readableDate}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FontAwesome name="cloud-upload" />
                                        </td>
                                        <td>
                                            Deployed{' '}
                                            <TimeAgo
                                                formatter={buildFormatter(engStrings)}
                                                date={this.props.deploy.date}
                                                live
                                                title={this.props.deploy.readableDate}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div onClick={() => this.open()}>
                            <FontAwesome name="info-circle" /> Build
                        </div>
                    )}
                </div>
            </Draggable>
        );
    }
}

function mapStateToProps(state) {
    return {
        build: state.app.build,
        deploy: state.app.deploy
    };
}

export default connect(mapStateToProps)(AppInfo);



// WEBPACK FOOTER //
// ./src/components/AppInfo/AppInfo.jsx